import React from 'react';

const ElecsumGreenPage = (): JSX.Element => (
  <div>
    <text>ElecsumGreen</text>
  </div>
);

export default ElecsumGreenPage;
